import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowRightIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M9.32629 2.85758C9.57611 2.60776 9.96203 2.57694 10.2458 2.76419L10.3612 2.85758L15.9862 8.48258C16.2718 8.76815 16.2718 9.23192 15.9862 9.51749L10.3612 15.1425C10.0756 15.4281 9.61187 15.4281 9.32629 15.1425C9.04072 14.8569 9.04072 14.3931 9.32629 14.1076L13.7021 9.73172H2.53125C2.12739 9.73172 1.79956 9.40389 1.79956 9.00003C1.79956 8.59617 2.12739 8.26834 2.53125 8.26834H13.7021L9.32629 3.89249L9.23291 3.77713C9.04566 3.49332 9.07648 3.10739 9.32629 2.85758Z"
      fill="currentColor"
    />
  </svg>
);
